import React from "react";
import { NavLink } from "react-router-dom";
import IAppStore from "app/IAppStore";
import ComponentRegistry from "common/componentRegistry";
import { Popover, OverlayTrigger, Spinner } from "react-bootstrap";
import * as ProducerActions from "./producers.action";
import notificationService from "common/notificationService";
import { SettingsComponentProps } from "../settingsComponentProps";
import "./Producer.css"
import UploadedWithErrors from "./UploadedWithErrors"
import ProducerBulkUploadResponse from "./uploadProducersResponse"
import UploadSuccess from "./UploadSuccess"
import { CSVLink } from "react-csv"
import { UploadProducerHelpContent } from "./UploadProducerHelpContent";
import UploadBulkFile from "common/ui/UploadBulkFile";
import UploadedWithNoErrors from "common/ui/UploadedWithNoErrors";

interface UploadProducersPageProps {
    producerBulkUploadResponse: ProducerBulkUploadResponse;
}

interface UploadProducersPageActions {
    uploadProducers: (selectedFile: any) => any;
    importProducers: (selectedFile: any) => any;
}

type UploadProducersPageState = {
    showFileUploadContent: boolean;
    showErrorsContent: boolean;
    showNoErrorsContent: boolean;
    showImportModal: boolean;
    isSubmitting: boolean;
    fileName: string;
    selectedFile: any;
    showImportSuccessContent: boolean;
    recordsFound: number;
}

class UploadProducersPage extends React.Component<UploadProducersPageProps & UploadProducersPageActions & SettingsComponentProps, UploadProducersPageState> {
    state = {
        showImportModal: false,
        showFileUploadContent: true,
        showErrorsContent: false,
        showNoErrorsContent: false,
        isSubmitting: false,
        fileName: null as string,
        selectedFile: null as any,
        showImportSuccessContent: false,
        recordsFound: 0
    };

    async onFileDrop(acceptedFiles: any[]) {
        try
        {        
            if (acceptedFiles.length > 0) {
                this.setState({ isSubmitting: true, selectedFile: acceptedFiles[0] });
                await this.props.uploadProducers(acceptedFiles[0]);
                this.setState({
                    showFileUploadContent: false, isSubmitting: false, fileName: acceptedFiles[0].path
                });
                if (this.props.producerBulkUploadResponse != null) {
                    this.setState({ recordsFound: this.props.producerBulkUploadResponse.totalRecords });
                    if (this.props.producerBulkUploadResponse.errorCount > 0)
                        this.setState({ showErrorsContent: true, showNoErrorsContent: false });
                    else if (this.props.producerBulkUploadResponse.errorCount === 0)
                        this.setState({ showErrorsContent: false, showNoErrorsContent: true });
                }
            }
        }
        catch {
            notificationService.error(`Error uploading file`);
            this.onFileRemoved();
        }
    }

    onFileRemoved() {
        this.setState({
            showErrorsContent: false, showNoErrorsContent: false, selectedFile: null as any,
            showFileUploadContent: true, fileName: null as string, showImportSuccessContent: false,
            isSubmitting: false
        });
    }

    async onImportSubmit() {
        try {
            this.setState({ isSubmitting: true });
            await this.props.importProducers(this.state.selectedFile);
            this.setState({
                showFileUploadContent: false, isSubmitting: false, showErrorsContent: false,
                showNoErrorsContent: false, showImportSuccessContent: false
            });
            if (this.props.producerBulkUploadResponse.errorCount > 0) {
                this.setState({ showErrorsContent: true });
            }
            else
                this.setState({ showImportSuccessContent: true });
        }
        catch {
            notificationService.error(`Error importing producer`);
        }
    }

    render() {
        const csvData = [
            ["FirstName", "LastName", "BusinessName", "UseBusinessName", "AccountIds", "AccountNames", "Phone", "Email", "PostalCode"],
            ["First", "Last", "Business", "", "111, 222, 333", "Acc1, Acc2, Acc3", "555-555-5555", "email@example.com", "11111"],
        ];
        return (
            <>
                <div className="container-fluid">
                    <div className="row" >
                        <div className="col">
                            <NavLink to="/settings/customers/" >
                                <i className="fa fa-arrow-left arrow-left"></i>{" "}
                                <span className="go-back-text">Import Customers</span>
                            </NavLink>
                        </div>
                        <div className="col" style={{ textAlign: "right" }}>
                            <span className="info-text">
                                <OverlayTrigger placement="left" overlay={producerUploadPopover}>
                                    <span><i className="fa fa-info-circle info-circle"></i>{" "}FORMATTING HELP</span>
                                </OverlayTrigger>
                                    </span>{"    "}
                            <CSVLink data={csvData} filename={"BulkUploadCustomers.csv"}>
                                <i className="fa fa-download info-circle"></i>
                                <span className="info-text"> DOWNLOAD BLANK TEMPLATE</span></CSVLink>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            {this.state.isSubmitting &&
                                <div className="d-flex justify-content-center" style={{ position: "absolute" }}>
                                    <Spinner animation="border" />
                                </div>
                            }
                            {(!this.state.isSubmitting && this.state.showErrorsContent) && (<UploadedWithErrors
                                producerBulkUploadResponse={this.props.producerBulkUploadResponse}
                                fileName={this.state.fileName}
                                onFileRemoved={() => this.onFileRemoved()}
                            />)}
                            {this.state.showFileUploadContent && <UploadBulkFile
                                onDrop={(acceptedFiles: any[]) => this.onFileDrop(acceptedFiles)}
                                isUploadInProgress = {this.state.isSubmitting}
                            />}
                            {(!this.state.isSubmitting && this.state.showNoErrorsContent) && <UploadedWithNoErrors
                                fileName={this.state.fileName}
                                recordsFound={this.props.producerBulkUploadResponse.totalRecords}
                                onFileRemoved={() => this.onFileRemoved()}
                                onImportSubmit={() => this.onImportSubmit()}
                            />}
                            {(!this.state.isSubmitting && this.state.showImportSuccessContent) && <UploadSuccess
                                recordsFound={this.state.recordsFound}
                                onFileRemoved={() => this.onFileRemoved()}
                            />}
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

const component = ComponentRegistry.register<UploadProducersPageProps, UploadProducersPageActions>(
    UploadProducersPage
)
    .useState((state: IAppStore) => {
        return {
            producerBulkUploadResponse: state.producerBulkUploadResponse
        };
    })
    .useActions({
        uploadProducers: ProducerActions.uploadProducers,
        importProducers: ProducerActions.importProducers
    })
    .build();


const producerUploadPopover = (
    <Popover id="producerPopover">
        <Popover.Title as="h3">
            <strong>Import Formatting Help</strong>
        </Popover.Title>
        <Popover.Content> {UploadProducerHelpContent} </Popover.Content>
    </Popover>
);

export default component;
